import { StaticJsonRpcProvider } from '@ethersproject/providers'
import { getEthereumNodeUrl, getRpcUrlByChainId } from 'utils/getRpcUrl'

export const RPC_URL = getEthereumNodeUrl()

export const simpleRpcProvider = new StaticJsonRpcProvider(RPC_URL)

export const getSimpleRpcProviderByChainId = (chainId: number) => {
  return new StaticJsonRpcProvider(getRpcUrlByChainId(chainId))
}
